import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  AfterViewInit
} from '@angular/core';
import * as L from 'leaflet';
import { Location } from '../location';
import { MapService } from '../../services/map.service';
import { timer } from 'rxjs/observable/timer';
import { RoutingMachineService } from '@app/shared/services/routing-machine.service';
import { Subject, BehaviorSubject } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapComponent implements AfterViewInit, OnDestroy {
  orderMarkers = [];
  address: string;
  InitMap = new BehaviorSubject(false);
  mapState = this.InitMap.pipe(
    filter(state => state),
    take(1)
  );

  currentCabs = [];
  currentOrder: any;
  cab: any = {};
  orders = [];
  incity = '';
  intercity = '';
  boundary = '';

  constructor(
    private mapService: MapService,
    private routingMachineService: RoutingMachineService
  ) {
    this.address = '';
  }

  @Input('focus') set focus(par) {
    this.mapService.addCab(par);
  }

  @Input('orders')
  set transformOrderMarkers(orders) {
    this.orders = orders;
    this.orderMarkers = orders.map(item => {
      return {
        id: item.id,
        status: item.status,
        created_at: item.created_at,
        start_point: {
          lat: item.waypoints[0].lat,
          lng: item.waypoints[0].lng
        },
        address: item.waypoints[0].name,
        cost: item.fare.amount
      };
    });
  }

  @Input('cabs') set cabs(cabs) {
    this.setCabs(cabs);
  }

  setCabs(cabs) {
    this.mapState.subscribe(() => {
      let add = cabs.filter(
        el => !this.currentCabs.find(el1 => el.id == el1.id)
      );
      let remove = this.currentCabs.filter(
        el => !cabs.find(el1 => el.id == el1.id)
      );
      let update = this.currentCabs.filter(el =>
        cabs.find(el1 => el.id == el1.id)
      );
      this.currentCabs = cabs;
      this.mapService.addCabs(add, true);
      this.mapService.removeCabs(remove);
      this.mapService.moveCabs(update);
    });
  }

  @Input('currentOrder')
  set order(order) {
    this.setOrder(order);
  }

  @Input('followDriver')
  set followDriver(val) {
    this.mapState.subscribe(() => {
      this.mapService.followDriver = val;
      this.setCabs(this.currentCabs);
    });
  }

  @Input('showAllDrivers')
  set showAllDrivers(val) {
    this.mapState.subscribe(() => {
      this.mapService.showAllDrivers = val;
      this.mapService.removeAllCabs();
      this.mapService.addCabs(this.currentCabs);
    });
  }

  drawAllPoly() {
    this.mapState.subscribe(() => {
      this.mapService.removePoly();
      this.mapService.drawPoly(this.incity);
      this.mapService.drawPoly(this.intercity, { color: 'green' });

      this.mapService.drawPoly(
        this.boundary,
        { color: 'grey', weight: 1 },
        !this.incity && !this.intercity
      );
    });
  }

  @Input('boundary')
  set drawBoundary(poly) {
    this.boundary = poly;
    if (poly) {
      this.drawAllPoly();
    }
  }

  @Input('polyline')
  set drawPolyline(poly) {
    this.incity = poly;
    if (poly) {
      this.drawAllPoly();
    }
  }

  @Input('intercityPoly')
  set drawIntercityPolyline(poly) {
    this.intercity = poly;
    if (poly) {
      this.drawAllPoly();
    }
  }

  @Input('points')
  set drawPoints(points) {
    this.mapState.subscribe(() => {
      let markers = [];
      this.mapService.removeOrderPins();
      points.forEach((point, index) => {
        markers = this.mapService.addOrderPin(point.lat, point.lng, index + 1);
      });
      if (markers.length) {
        this.mapService.fitBounds(markers);
      }
    });
  }

  setOrder(order) {
    this.mapState.subscribe(() => {
      this.currentOrder = order;
      this.mapService.removePoly();
      this.mapService.removeOrderPins();
      if (!order) {
        return;
      }
      if (!(this.cab && this.mapService && this.currentOrder)) {
        return;
      }
      this.routingMachineService
        .routeAll(
          this.currentOrder.waypoints.sort((a, b) => a.ord - b.ord) || []
        )
        .subscribe(res => {
          this.mapService.drawPoly(res.routes[0].geometry);
        });
      order.waypoints.map(waypoint =>
        this.mapService.addOrderPin(
          waypoint.lat,
          waypoint.lng,
          waypoint.ord + 1
        )
      );
    });
  }

  @Input('currentCab')
  set currentCab(cab) {
    this.mapState.subscribe(() => {
      this.mapService.removeAllCabs();
      this.mapService.currentCab = cab;
      this.mapService.addCabs(this.currentCabs, false);
    });
  }

  ngAfterViewInit() {
    console.log("TCL: MapComponent -> ngAfterViewInit -> ngAfterViewInit")
    timer(100).subscribe(() => {
    console.log('map',this.mapService.map);
   

      const location = new Location();
      location.address = 'Mariupol';
      location.latlng = L.latLng(47.097132, 37.543363);
      console.log('initmap');

      const map = L.map('map', {
        zoomControl: false,
        center: location.latlng,
        zoom: 12,
        minZoom: 2,
        maxZoom: 18,
        layers: [this.mapService.baseMaps.Utax]
      });

      L.control.zoom({ position: 'topleft' }).addTo(map);
      L.control.scale().addTo(map);

      this.address = location.address;
      this.mapService.map = map;
      this.InitMap.next(true);
    
    });
  }

  ngOnDestroy() {
    this.mapService.map.remove();
    this.mapService.map = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/map/map.component.ts